import { gql, TypedDocumentNode } from '@apollo/client'

type SearchBusinessPartnersAutocompleteData = {
  searchBusinessPartners: {
    id: string
    name: string
  }[]
}
type SearchBusinessPartnersAutocompleteVars = { query: string }

export const SEARCH_BUSINESS_PARTNERS_AUTOCOMPLETE: TypedDocumentNode<
  SearchBusinessPartnersAutocompleteData,
  SearchBusinessPartnersAutocompleteVars
> = gql`
  query searchBusinessPartnersTypeahead($query: String!) {
    searchBusinessPartners(query: $query) {
      id
      name
    }
  }
`

type GetBusinessPartnerByIdData = {
  businessPartner: {
    id: string
    name: string
    role: {
      id: number
      name: string
    }[]
  }
}
type GetBusinessPartnerByIdVars = { id: string }

export const GET_BUSINESS_PARTNER_BY_ID: TypedDocumentNode<
  GetBusinessPartnerByIdData,
  GetBusinessPartnerByIdVars
> = gql`
  query getBusinessPartnerById($id: ID!) {
    businessPartner(id: $id) {
      id
      name
      role {
        id
        name
      }
    }
  }
`
